import { PERMISSION_ROLE, PERMISSION_TYPE } from "lib/constants";

export const PERMISSION_OPTIONS = [
    { text: "Admin", value: PERMISSION_ROLE.ADMIN },
    { text: "Editor", value: PERMISSION_ROLE.EDITOR },
    { text: "View-only", value: PERMISSION_ROLE.VIEWER },
    { text: "No access", value: PERMISSION_ROLE.NONE },
];

const permissionTypeToRole = new Map([
    [PERMISSION_TYPE.ADMIN, [PERMISSION_ROLE.ADMIN]],
    [PERMISSION_TYPE.EDIT, [PERMISSION_ROLE.ADMIN, PERMISSION_ROLE.EDITOR]],
    [PERMISSION_TYPE.VIEW, [PERMISSION_ROLE.ADMIN, PERMISSION_ROLE.EDITOR, PERMISSION_ROLE.VIEWER]],
    [PERMISSION_TYPE.NONE, [PERMISSION_ROLE.ADMIN]],
]);

export const validRolesForPermissionType = (permissionType) =>
    permissionTypeToRole.get(permissionType) || permissionTypeToRole.get(PERMISSION_TYPE.NONE);
